import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';

import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { ActionGroup } from '../../../../elements/public_api';
import { LoadingBehaviorSubject } from '../../../../helpers/loading-behavior-subject.helper';
import { Comparable, Trackable } from '../../../../helpers/public_api';
import { ShRecordsMapComponent } from '../../../../maps/components/records-map/records-map.component';

@Component({
    standalone: true,
    selector: 'sh-generic-map',
    templateUrl: './generic-map.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ShRecordsMapComponent]
})
export class ShGenericMapComponent<T extends Comparable & Trackable> implements OnDestroy {
    private readonly destroy$: Subject<void> = new Subject<void>();
    public loading$: LoadingBehaviorSubject = new LoadingBehaviorSubject(false);

    @Input() loadingMsg = '';
    @Input() loadingFailedMsg = '';
    @Input() emptyListMsg = '';

    @Input() mapElements: T[] = [];
    @Input() set isLoading(loading: boolean) {
        this.loading$.next(loading);
    }

    @Input() hasError = false;
    @Input() actionItems?: ActionGroup[];

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
